let pos_settings_PurchaseHistoryList = require("../../templates/pos/settings/PurchaseHistoryList.handlebars");
let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
let i18n = require("../../utils/i18n");
let PurchaseHistoryCollection = require("../../collection/PurchaseHistoryCollection.js");

let main = function (Backbone, _, i18n, PurchaseHistoryCollection) {
    return Backbone.View.extend({

        events: {

        },

        initialize: function (options) {
            this.collection = new PurchaseHistoryCollection();
        },

        render: function () {
            this.collection.fetch({
                data: $.param({
                    organizationId: this.model.get("organizationId")
                }),
                success:_.bind(this.showList, this)
            });
            return this;
        },

        showList: function () {
            this.$el.html(pos_settings_PurchaseHistoryList({collection: this.collection.toJSON()}));
        }
    });
};

let exportedValue = main(Backbone, _, i18n, PurchaseHistoryCollection);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/settings/PurchaseHistoryListView.js